"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _superagent = _interopRequireDefault(require("superagent"));

var _MulesoftUtils = require("@icare/core/lib/utils/MulesoftUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DEFAULT_HEADERS = {
  // eslint-disable-next-line quote-props
  Accept: 'application/json',
  'Cache-Control': 'no-cache'
};
/**
 * icare identity service
 */

var IdentityService = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param baseUrl
   * @param auth
   * @param requestHeaders
   */
  function IdentityService(baseUrl, auth) {
    var requestHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_HEADERS;

    _classCallCheck(this, IdentityService);

    if (!baseUrl) {
      throw 'Missing baseUrl';
    }

    this._baseUrl = baseUrl.replace(/\/$/, '');
    this._auth = auth;
    this._headers = requestHeaders;
  }
  /**
   * Retrieve user's secret question
   *
   * @param {String} token - URL specified recoveryToken
   * @returns {Promise}
   */


  _createClass(IdentityService, [{
    key: "retrieveQuestion",
    value: function () {
      var _retrieveQuestion = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token) {
        var endpoint, payload, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (token) {
                  _context.next = 2;
                  break;
                }

                throw 'Missing token';

              case 2:
                endpoint = "".concat(this._baseUrl, "/v1/identity/passwords/recovery/tokens/verify");
                payload = {
                  data: {
                    type: 'RecoveryTokenVerificationRequest',
                    attributes: {
                      recoveryToken: token
                    }
                  }
                };
                _context.prev = 4;
                _context.next = 7;
                return _superagent.default.post(endpoint, payload).set(this._headers).set('Content-Type', 'application/json').accept('application/vnd.api+json, application/json');

              case 7:
                response = _context.sent;
                return _context.abrupt("return", {
                  stateToken: response.body.data.attributes.stateToken,
                  question: response.body.data.included.attributes.recoveryQuestion.question
                });

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                (0, _MulesoftUtils.throwAPIErrorSafely)(_context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 11]]);
      }));

      function retrieveQuestion(_x) {
        return _retrieveQuestion.apply(this, arguments);
      }

      return retrieveQuestion;
    }()
    /**
     * Submits input answer to user's secret question
     *
     * @param {String} answer - Input answer
     * @param {String} token - stateToken retained from question retrieval API response
     * @returns {Promise}
     */

  }, {
    key: "verifyAnswer",
    value: function () {
      var _verifyAnswer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(answer, token) {
        var endpoint, payload, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (answer) {
                  _context2.next = 2;
                  break;
                }

                throw 'Missing answer';

              case 2:
                if (token) {
                  _context2.next = 4;
                  break;
                }

                throw 'Missing token';

              case 4:
                endpoint = "".concat(this._baseUrl, "/v1/identity/passwords/recovery/questions/verify");
                payload = {
                  data: {
                    type: 'RecoveryQuestionVerificationRequest',
                    attributes: {
                      stateToken: token,
                      answer: answer
                    }
                  }
                };
                _context2.prev = 6;
                _context2.next = 9;
                return _superagent.default.post(endpoint, payload).set(this._headers).set('Content-Type', 'application/json').accept('application/vnd.api+json, application/json');

              case 9:
                response = _context2.sent;
                return _context2.abrupt("return", {
                  stateToken: response.body.data.attributes.stateToken
                });

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](6);
                (0, _MulesoftUtils.throwAPIErrorSafely)(_context2.t0);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 13]]);
      }));

      function verifyAnswer(_x2, _x3) {
        return _verifyAnswer.apply(this, arguments);
      }

      return verifyAnswer;
    }()
    /**
     * Change users password with a valid forgot password state token
     * This method is used after the validate secret Q & A
     *
     * @param {String} token - stateToken retained from secret question validation
     * @param {String} password - The new password
     * @returns {Promise}
     */

  }, {
    key: "changePasswordWithToken",
    value: function () {
      var _changePasswordWithToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(token, password) {
        var endpoint, payload, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (password) {
                  _context3.next = 2;
                  break;
                }

                throw 'Missing password';

              case 2:
                if (token) {
                  _context3.next = 4;
                  break;
                }

                throw 'Missing token';

              case 4:
                _context3.prev = 4;
                endpoint = "".concat(this._baseUrl, "/v1/identity/passwords/reset");
                payload = {
                  data: {
                    type: 'PasswordResetRequest',
                    attributes: {
                      stateToken: token,
                      newPassword: password
                    }
                  }
                };
                _context3.next = 9;
                return _superagent.default.post(endpoint, payload).set(this._headers).set('Content-Type', 'application/json').accept('application/vnd.api+json, application/json');

              case 9:
                response = _context3.sent;
                return _context3.abrupt("return", {
                  expiresAt: response.body.data.attributes.expiresAt,
                  status: response.body.data.attributes.status,
                  sessionToken: response.body.data.attributes.sessionToken
                });

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](4);
                (0, _MulesoftUtils.throwAPIErrorSafely)(_context3.t0);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 13]]);
      }));

      function changePasswordWithToken(_x4, _x5) {
        return _changePasswordWithToken.apply(this, arguments);
      }

      return changePasswordWithToken;
    }()
    /**
     * Change users password
     * This is a straight change with no secret question as per the method above
     *
     * @param oldPassword
     * @param newPassword
     * @returns {Promise<boolean>}
     */

  }, {
    key: "changePassword",
    value: function () {
      var _changePassword = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(oldPassword, newPassword) {
        var endpoint, payload;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (oldPassword) {
                  _context4.next = 2;
                  break;
                }

                throw 'Missing old password';

              case 2:
                if (newPassword) {
                  _context4.next = 4;
                  break;
                }

                throw 'Missing new password';

              case 4:
                _context4.prev = 4;
                endpoint = "".concat(this._baseUrl, "/v1/identity/users/me/passwords/change");
                payload = {
                  data: {
                    type: 'PasswordChangeRequest',
                    attributes: {
                      oldPassword: oldPassword,
                      newPassword: newPassword
                    }
                  }
                };
                _context4.next = 9;
                return _superagent.default.post(endpoint, payload).set(this._headers).set('Authorization', "Bearer ".concat(this._auth.getAccessToken())).set('Content-Type', 'application/json').accept('application/vnd.api+json, application/json');

              case 9:
                return _context4.abrupt("return", true);

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](4);
                (0, _MulesoftUtils.throwAPIErrorSafely)(_context4.t0);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 12]]);
      }));

      function changePassword(_x6, _x7) {
        return _changePassword.apply(this, arguments);
      }

      return changePassword;
    }()
    /**
     * Triggers secret question form
     * @param firstName
     * @param lastName
     * @param emailAddress
     * @returns {Promise<*>}
     */

  }, {
    key: "submitSecretQuestionForm",
    value: function () {
      var _submitSecretQuestionForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(firstName, lastName, emailAddress) {
        var endpoint, payload;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (firstName) {
                  _context5.next = 2;
                  break;
                }

                throw 'First name is missing';

              case 2:
                if (lastName) {
                  _context5.next = 4;
                  break;
                }

                throw 'Last name is missing';

              case 4:
                if (emailAddress) {
                  _context5.next = 6;
                  break;
                }

                throw 'Email Address is missing';

              case 6:
                _context5.prev = 6;
                endpoint = '/api/sentforgotpassemail';
                payload = {
                  firstName: firstName,
                  lastName: lastName,
                  emailAddress: emailAddress
                };
                _context5.next = 11;
                return _superagent.default.post(endpoint, payload).set(this._headers).set('Content-Type', 'application/json').accept('application/vnd.api+json, application/json');

              case 11:
                return _context5.abrupt("return", true);

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](6);
                (0, _MulesoftUtils.throwAPIErrorSafely)(_context5.t0);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[6, 14]]);
      }));

      function submitSecretQuestionForm(_x8, _x9, _x10) {
        return _submitSecretQuestionForm.apply(this, arguments);
      }

      return submitSecretQuestionForm;
    }()
    /**
     * Triggers a password reset recovery (eg reset email or sms)
     * @param username
     * @returns {Promise<boolean>}
     */

  }, {
    key: "recoverPassword",
    value: function () {
      var _recoverPassword = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(username, oktaEnv, portalIdentifier) {
        var lob, endpoint, payload;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (username) {
                  _context6.next = 2;
                  break;
                }

                throw 'Missing username';

              case 2:
                // lob=portalIdentifier does not need to be appended to all portals - only Claims 2.1b needs it so far
                lob = portalIdentifier ? "?lob=".concat(portalIdentifier) : '';
                endpoint = "".concat(this._baseUrl, "/v1/identity/passwords/recovery").concat(lob);
                payload = {
                  data: {
                    type: 'PasswordRecoveryRequest',
                    attributes: {
                      username: username,
                      environment: oktaEnv
                    }
                  }
                };
                _context6.prev = 5;
                _context6.next = 8;
                return _superagent.default.post(endpoint).send(payload).set(this._headers).set('Content-Type', 'application/json').accept('application/vnd.api+json, application/json');

              case 8:
                return _context6.abrupt("return", true);

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](5);
                (0, _MulesoftUtils.throwAPIErrorSafely)(_context6.t0);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 11]]);
      }));

      function recoverPassword(_x11, _x12, _x13) {
        return _recoverPassword.apply(this, arguments);
      }

      return recoverPassword;
    }()
    /**
     * Validates a registration token and returns a new stateToken
     * @param token
     * @returns {Promise<*>}
     */

  }, {
    key: "activateAccount",
    value: function () {
      var _activateAccount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(token) {
        var endpoint, payload, response, data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (token) {
                  _context7.next = 2;
                  break;
                }

                throw 'Missing token';

              case 2:
                endpoint = "".concat(this._baseUrl, "/v1/identity/users/activateAccount");
                payload = {
                  data: {
                    type: 'ActivateUserRequest',
                    attributes: {
                      token: token
                    }
                  }
                };
                _context7.prev = 4;
                _context7.next = 7;
                return _superagent.default.post(endpoint, payload).set(this._headers).set('x-token', token).set('Content-Type', 'application/vnd.api+json').accept('application/vnd.api+json, application/json');

              case 7:
                response = _context7.sent;
                data = response.body.data;
                return _context7.abrupt("return", {
                  id: data.id,
                  stateToken: data.attributes.stateToken,
                  firstName: data.attributes.profile.firstName,
                  lastName: data.attributes.profile.lastName,
                  emailAddress: data.attributes.profile.login
                });

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7["catch"](4);
                (0, _MulesoftUtils.throwAPIErrorSafely)(_context7.t0);

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 12]]);
      }));

      function activateAccount(_x14) {
        return _activateAccount.apply(this, arguments);
      }

      return activateAccount;
    }()
    /**
     * Confirms account creation with email token validation
     * @param question
     * @param answer
     * @param password
     * @param stateToken
     * @param id
     * @returns {Promise<boolean>}
     */

  }, {
    key: "confirmAccountPostActivation",
    value: function () {
      var _confirmAccountPostActivation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(question, answer, password, stateToken, id) {
        var endpoint, payload, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (stateToken) {
                  _context8.next = 2;
                  break;
                }

                throw 'Missing state token';

              case 2:
                _context8.prev = 2;
                endpoint = "".concat(this._baseUrl, "/v1/identity/workersInsurance/confirmAccount");
                payload = {
                  data: {
                    type: 'ConfirmUserPostActivationRequest',
                    id: id,
                    attributes: {
                      stateToken: stateToken,
                      password: password,
                      recoveryCredentials: [{
                        question: question,
                        answer: answer
                      }]
                    }
                  }
                };
                _context8.next = 7;
                return _superagent.default.post(endpoint, payload).set(this._headers).set('x-token', stateToken).set('Content-Type', 'application/vnd.api+json').accept('application/vnd.api+json, application/json');

              case 7:
                response = _context8.sent;
                return _context8.abrupt("return", response.body);

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8["catch"](2);
                (0, _MulesoftUtils.throwAPIErrorSafely)(_context8.t0);

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[2, 11]]);
      }));

      function confirmAccountPostActivation(_x15, _x16, _x17, _x18, _x19) {
        return _confirmAccountPostActivation.apply(this, arguments);
      }

      return confirmAccountPostActivation;
    }()
    /**
     * Resend register accout activation link to registered email
     * @param email
     * @returns {Promise<boolean>}
     */

  }, {
    key: "resendActivationLink",
    value: function () {
      var _resendActivationLink = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(email, portalIdentifier) {
        var endpoint, payload, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                endpoint = "".concat(this._baseUrl, "/v1/identity/users/reactivateAccount?lob=").concat(portalIdentifier);
                payload = {
                  data: {
                    type: 'ReactivateUserRequest',
                    attributes: {
                      email: email
                    }
                  }
                };
                _context9.next = 5;
                return _superagent.default.post(endpoint, payload).set(this._headers).set('Content-Type', 'application/vnd.api+json').accept('application/vnd.api+json, application/json');

              case 5:
                response = _context9.sent;
                return _context9.abrupt("return", response.body);

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9["catch"](0);
                (0, _MulesoftUtils.throwAPIErrorSafely)(_context9.t0);

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 9]]);
      }));

      function resendActivationLink(_x20, _x21) {
        return _resendActivationLink.apply(this, arguments);
      }

      return resendActivationLink;
    }()
  }]);

  return IdentityService;
}();

exports.default = IdentityService;
//# sourceMappingURL=IdentityService.js.map